<script>
export default {
  name: "aside-calendar-svg"
}
</script>

<template>
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 11.25C4 10.5859 4.54688 10 5.25 10C5.91406 10 6.5 10.5859 6.5 11.25C6.5 11.9531 5.91406 12.5 5.25 12.5C4.54688 12.5 4 11.9531 4 11.25ZM12.75 13.75C13.4141 13.75 14 14.3359 14 15C14 15.7031 13.4141 16.25 12.75 16.25C12.0469 16.25 11.5 15.7031 11.5 15C11.5 14.3359 12.0469 13.75 12.75 13.75ZM7.75 11.25C7.75 10.7422 8.14062 10.3125 8.6875 10.3125H13.0625C13.5703 10.3125 14 10.7422 14 11.25C14 11.7969 13.5703 12.1875 13.0625 12.1875H8.6875C8.14062 12.1875 7.75 11.7969 7.75 11.25ZM9.3125 14.0625C9.82031 14.0625 10.25 14.4922 10.25 15C10.25 15.5469 9.82031 15.9375 9.3125 15.9375H4.9375C4.39062 15.9375 4 15.5469 4 15C4 14.4922 4.39062 14.0625 4.9375 14.0625H9.3125ZM6.1875 2.5H11.8125V0.9375C11.8125 0.429688 12.2031 0 12.75 0C13.2578 0 13.6875 0.429688 13.6875 0.9375V2.5H15.25C16.6172 2.5 17.75 3.63281 17.75 5V17.5C17.75 18.9062 16.6172 20 15.25 20H2.75C1.34375 20 0.25 18.9062 0.25 17.5V5C0.25 3.63281 1.34375 2.5 2.75 2.5H4.3125V0.9375C4.3125 0.429688 4.70312 0 5.25 0C5.75781 0 6.1875 0.429688 6.1875 0.9375V2.5ZM2.125 17.5C2.125 17.8516 2.39844 18.125 2.75 18.125H15.25C15.5625 18.125 15.875 17.8516 15.875 17.5V7.5H2.125V17.5Z" fill="#6C757D"/>
  </svg>

</template>

<style scoped>

</style>
